import { ReservationCheckoutModeEnum } from '../../../../tenant/settings/enums/reservation-checkout-mode.enum';
import { ReservationPaymentAmountEnum } from '../../../../tenant/settings/enums/reservation-payment-amount.enum';
import { ResolveReservationPaymentAmountParams } from '../interfaces/resolve-reservation-payment-amount-params.interface';

import { toRoundedAmount } from '../../../functions/to-rounded-amount.function';

/**
 * Resolves the payment amount to charge from tenant settings and quoted figures.
 */
export function resolveReservationPaymentAmount(
  params: ResolveReservationPaymentAmountParams,
): number {
  const {
    settings,
    depositAmount,
    computedTotalGross,
    discountedStandardGross,
  } = params;

  if (
    settings?.reservationMode === ReservationCheckoutModeEnum.WITHOUT_PAYMENT
  ) {
    return 0;
  }

  const paymentAmount =
    settings?.reservationPaymentAmount ?? ReservationPaymentAmountEnum.DEPOSIT;

  switch (paymentAmount) {
    case ReservationPaymentAmountEnum.NONE:
      return 0;
    case ReservationPaymentAmountEnum.FULL_AMOUNT:
      return toRoundedAmount(computedTotalGross);
    case ReservationPaymentAmountEnum.DEPOSIT:
    default: {
      const deposit = Number(depositAmount ?? 0);
      return toRoundedAmount(deposit > 0 ? deposit : discountedStandardGross);
    }
  }
}
